import { connect, mapReadPretty } from '@eastcoal/formily/exports/react'

import { KindRootNodeCheckbox as LocalKindRootNodeCheckbox } from '../../components/Kind/RootNode/Checkbox'

export const KindRootNodeCheckbox = connect(
  LocalKindRootNodeCheckbox,
  mapReadPretty(LocalKindRootNodeCheckbox, {
    disabled: true
  })
)
